export default "__VITE_ASSET__hyy42kWT__"